import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CommonSelect from "../../../core/common/commonSelect";
import {
  driverFilter2,
  driverName,
  GPSDevice,
  status,
  vehicleModel,
  VehicleNumber,
} from "../../../core/common/selectoption/selectoption";
import { TableData } from "../../../core/data/interface";
import Table from "../../../core/common/dataTable/index";
import TooltipOption from "../../../core/common/tooltipOption";
import TransportModal from "./transportModal";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { transportVehicles } from "../../../core/data/json/transport_vehicle";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import {
  lastModified,
} from "../../../core/common/selectoption/selectoption";
import TodoModal from "../../../core/modals/todoModal";
import { ApolloClient, gql, InMemoryCache, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Modal } from "react-bootstrap";
import {
  GoogleMap,
  LoadScript,
  DirectionsService,
  DirectionsRenderer,
  Marker,
  InfoWindow,
  Polyline,
  useJsApiLoader,
} from '@react-google-maps/api';

const GET_VEHICLES = gql`
  query GetAllVehicleDetails($clientLoginId: Int!) {
    getAllVehicleDetails(
      clientLoginId: $clientLoginId
    ) {
      vehicleType
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`;


const GENERATE_AUTH_TOKEN = gql`
    query generateAuthTokenAPI($username: String!, $password: String!) {
        generateAuthTokenAPI(username: $username, password: $password) {
            token
        }
    }
`;

const GET_LATEST_LOCATION = gql`
    query getLatestLocation($uniqueId: String!) {
        getDeviceLatestLocation(deviceId: $uniqueId) {
            timestamp
            latitude
            longitude
            haltStatus
            idlingStatus
            isOverspeed
            speed
            extBatVol
            isPrimaryBattery
            isNoGps
            address
        }
    }
`;


const client2 = new ApolloClient({
  uri: 'http://79.143.185.100:5500/graphql', // Remplacez par votre deuxième URI
  cache: new InMemoryCache(),
});

const GET_SONS_IN_BUS = gql`
  query getSonsInBus($clientId: Int!){
    getSonsInBus(clientId: $clientId){
      rfid
      name
      matricule
      vehicle_number
    }
  }
`;


interface VehicleDetail {
  vehicleType: string;
  vehicleNumber: string;
  deviceDetail: {
    uniqueDeviceId: string;
  };
}

interface GetAllVehiclesData {
  getAllVehicleDetails: VehicleDetail[];
}

const TransportVehicleDetails = () => {
  const initialCenter = { lat: 7.365302, lng: 12.343439 };
  const [center, setCenter] = useState(initialCenter);
  const [markerPosition, setMarkerPosition] = useState<any>();
  const [address, setAddress] = useState("");
  const [students, setStudents] = useState<any>([]);
  const mapContainerStyle = {
    width: '100%',
    height: '700px'
  };
  const [mapKey, setMapKey] = useState(0);
  // Hook pour charger le script Google Maps
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDp2ZqWgffPdF4qtCCe1NUsCEd8YWZbmTU",
  });
  const { id } = useParams();
  const imei = id;

  const carIconUrl = "../../assets/img/bus.png";


  const markerStyle = markerPosition
    ? {
      url: carIconUrl, // Assurez-vous que l'URL est correctement définie ici
      scaledSize: new window.google.maps.Size(50, 50), // Taille de l'icône
      rotation: 45, // Exemple de rotation
    }
    : null;

  const [authToken, setAuthToken] = useState(null);

  // Première requête pour générer le token
  const { data: authData, loading: authLoading, error: authError } = useQuery(GENERATE_AUTH_TOKEN, {
    variables: {
      username: "eneotrack",
      password: "Afr!Tr@ck"
    },
    onCompleted: (data) => {
      setAuthToken(data.generateAuthTokenAPI.token);
    }
  });


  // Utiliser useLazyQuery pour obtenir la dernière localisation
  const [getLocation, { data: locationData, loading: locationLoading, error: locationError }] = useLazyQuery(GET_LATEST_LOCATION);




  // Utiliser useLazyQuery pour obtenir la dernière localisation
  const [getSonsInBus, { data: busResponseData, loading: busResponseLoading, error: busResponseError }] = useLazyQuery(GET_SONS_IN_BUS);


  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);

  const fetchDataSonsInBus = async (id: any) => {
    try {
      if (authToken) {
        const { data } = await getSonsInBus({
          client: client2, // Utilise le premier client
          variables: {
            clientId: id,
          },
          /*   context: {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }, */
        });

        if (data?.getSonsInBus) {
          // console.log(data?.getSonsInBus);
          setStudents(data?.getSonsInBus)
        } else {
          console.error('No data returned from location query');
        }
      }
    } catch (error) {
      console.error('Error fetching location:', error);
    }
  };


  // Fonction pour récupérer les données de localisation
  const fetchData = async (record: string) => {
    if (authToken) {
      try {
        const { data } = await getLocation({
          variables: {
            uniqueId: record,
          },
          context: {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          },
        });

        if (data) {
          const newLat = parseFloat(data.getDeviceLatestLocation.latitude);
          const newLng = parseFloat(data.getDeviceLatestLocation.longitude);

          console.log('New Position:', { lat: newLat, lng: newLng });

          if (!isNaN(newLat) && !isNaN(newLng)) {
            setMarkerPosition({ lat: newLat, lng: newLng });
            setCenter({ lat: newLat, lng: newLng });
            setAddress(data.getDeviceLatestLocation.address);
          } else {
            console.error('Invalid coordinates:', data.getDeviceLatestLocation.latitude, data.getDeviceLatestLocation.longitude);
          }
        } else {
          console.error('No data returned from location query');
        }
      } catch (error) {
        console.error('Error fetching location:', error);
      }
    }
  };



  useEffect(() => {
    if (imei && authToken) {
      // Initial fetch
      fetchData(imei);
      fetchDataSonsInBus(1234);
      // Set up interval for refreshing data every 5 seconds
      const intervalId = setInterval(() => {
        fetchData(imei);
      }, 5000);

      // Cleanup interval on component unmount or imei change
      return () => clearInterval(intervalId);
    }
  }, [imei, authToken]);

  if (authLoading || locationLoading) return <p>Loading...</p>;
  if (authError) return <p>Error: {authError.message}</p>;
  if (locationError) return <p>Error: {locationError.message}</p>;






  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper notes-page-wrapper">
        <div className="content pb-4">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3 pb-3 border-bottom position-relative">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Transport Details</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Management </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Transport Details
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

            </div>
            <Link
              id="toggle_btn2"
              className="notes-tog position-absolute start-0 avatar avatar-sm rounded-circle bg-primary text-white"
              to="#"
            >
              <i className="fas fa-chevron-left" />
            </Link>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-12 sidebars-right theiaStickySidebar section-bulk-widget " >
              <div className="stickybar">
                <div className="border rounded-3 mt-4 bg-white p-3">
                  <div className="mb-3 pb-3 border-bottom">
                    <h4 className="d-flex align-items-center">
                      <i className="ti ti-file-text me-2" />
                      Student List
                    </h4>
                  </div>
                  <div className="" style={{ height: "630px", overflowY: "scroll" }}>

                    {students && students?.map((item: any) => (<div className="border-bottom pb-3 ">
                      <div className="border-start border-info border-3 shadow-sm p-3 mb-3 bg-white">
                        <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
                          <span className="avatar p-1 me-3 bg-primary-transparent flex-shrink-0">
                            <i className="ti ti-users-group text-info fs-20"></i>
                          </span>
                          <div className="flex-fill">
                            <h6 className="mb-1">{item?.name}</h6>
                            <p className="fs-12">
                              <i className="ti ti-school me-1"></i>CM2 A -  {item?.rfid}</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0 fs-12">
                            <i className="ti ti-clock me-1"></i>09:10AM - 10:50PM</p>

                        </div>
                      </div>
                    </div>))

                    }



                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 budget-role-notes">
              <div className="bg-white rounded-3  my-4 p-3 pb-0">
                <div className=" mb-3">

                  {isLoaded ? (
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      center={center}
                      zoom={20} // Niveau de zoom initial
                      onLoad={(map) => setMapInstance(map)}
                      options={{ zoomControl: true }} // Activer les contrôles de zoom
                    >
                      <Marker
                        key={`${markerPosition?.lat}-${markerPosition?.lng}`}
                        position={markerPosition}
                        //   label={{ text: `v`, color: "white", fontWeight: "bold" }}
                        icon={markerStyle || undefined}

                      />


                    </GoogleMap>
                  ) : (
                    <div>Loading map...</div>
                  )}
                </div>

              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransportVehicleDetails;
